import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgBookmarkFill(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7 2.75C6.30964 2.75 5.75 3.30964 5.75 4V28C5.75 28.461 6.00373 28.8846 6.41018 29.1021C6.81662 29.3196 7.3098 29.2958 7.69338 29.0401L16 23.5023L24.3066 29.0401C24.6902 29.2958 25.1834 29.3196 25.5898 29.1021C25.9963 28.8846 26.25 28.461 26.25 28V4C26.25 3.30964 25.6904 2.75 25 2.75H7Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBookmarkFill);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
